function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_102_52859)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 0C5.37253 0 0 5.37253 0 11.9999C0 18.6273 5.37253 24.0001 11.9999 24.0001C18.6273 24.0001 24.0001 18.6273 24.0001 11.9999C23.9926 5.37561 18.6245 0.00747067 11.9999 0ZM11.9999 22.7999C6.03523 22.7999 1.19993 17.9646 1.19993 11.9999C1.19993 6.03523 6.03523 1.19993 11.9999 1.19993C17.9646 1.19993 22.7999 6.03523 22.7999 11.9999C22.7931 17.9618 17.9618 22.7931 11.9999 22.7999Z",
  fill: "#ADCDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.595 7.3483C10.3454 7.13011 9.96638 7.1556 9.74819 7.40499C9.53022 7.6546 9.55571 8.03363 9.8051 8.25182L14.0889 11.9999L9.80488 15.7482C9.55527 15.9664 9.53 16.3454 9.74797 16.5948C9.96616 16.8444 10.3452 16.8699 10.5948 16.6517L15.3947 12.4517C15.525 12.3379 15.5997 12.1731 15.5997 11.9999C15.5997 11.8268 15.525 11.6622 15.3947 11.5482L10.595 7.3483Z",
  fill: "#2C61A5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_102_52859"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgScrollArrowIcon = function SvgScrollArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll-arrow-icon.b5857958.svg";
export { ForwardRef as ReactComponent };